// import VueSocketIO from 'vue-socket.io'
import store from '@/store/index'
import SocketIO from 'socket.io-client'
import * as cache from '@/assets/js/cache'
import deepCopy from 'json-deep-copy'

let socketIo = SocketIO('http://203.85.72.1:9191', {
  autoConnect: false,
  query: 'token=' + store.state.token
},function(){
  console.log(socketIo)
})

socketIo.on('connect', () => {
  socketIo.emit('login')
})

socketIo.on('reconnect', () => {
  socketIo.emit('login')
})

socketIo.on('backMessage',(data) => {
  console.log(data);
})

socketIo.on('message', (res) => {
  console.log(res)
  const data = res.data
  const user = store.state.user
  const chats = data.chat || []
  const likes = data.notification_like || []
  const comments = data.notification_comment || []
  const wallets = data.notification_wallet || []
  const follows = data.notification_follow || []
  for (let item of chats) {
    const msg = {
      'uid': item.sender.id,
      'ownerId': user.id,
      'from': item.sender.id,
      'nickname': item.sender.nickname,
      'tnickname': item.sender.nickname,
      'avatar': item.sender.avatar,
      'tavatar': item.sender.avatar,
      'content': item.content,
      'createdDate': item.createdDate / 1000
    }
    store.dispatch('addMsg', msg)
    store.dispatch('addNotify', user.id)
  }

  for (let item of likes) {
    let likeMsg = deepCopy(store.state.likeMsg)
    if (!likeMsg[user.id]) {
      likeMsg[user.id] = []
    }
    likeMsg[user.id].push(item)
    cache.setLikeMsg(likeMsg)
    store.commit('SET_UNREAD_LIKE_MSG', likeMsg)
  }

  for (let item of comments) {
    let commentMsg = deepCopy(store.state.commentMsg)
    if (!commentMsg[user.id]) {
      commentMsg[user.id] = []
    }
    commentMsg[user.id].push(item)
    cache.setCommentMsg(commentMsg)
    store.commit('SET_UNREAD_COMMENT_MSG', commentMsg)
  }

  for (let item of wallets) {
    let walletMsg = deepCopy(store.state.walletMsg)
    if (!walletMsg[user.id]) {
      walletMsg[user.id] = []
    }
    walletMsg[user.id].push(item)
    cache.setWalletMsg(walletMsg)
    store.commit('SET_UNREAD_WALLET_MSG', walletMsg)
  }

  for (let item of follows) {
    let followMsg = deepCopy(store.state.followMsg)
    if (!followMsg[user.id]) {
      followMsg[user.id] = []
    }
    followMsg[user.id].push(item)
    cache.setFollowMsg(followMsg)
    store.commit('SET_UNREAD_FOLLOW_MSG', followMsg)
  }
})

let Socket = {}

Socket.install = function (Vue) {
  Vue.prototype.$socket = socketIo
  // Vue.prototype.$socket = function () {
  //   return socketIo
  // }
}

export default Socket

// export default new VueSocketIO({
//   debug: false,
//   connection: socketIo,
//   vuex: {
//     store,
//     actionPrefix: 'SOCKET_',
//     mutationPrefix: 'SOCKET_'
//   }
// })



// WEBPACK FOOTER //
// ./src/assets/js/socketIo.js